import React from "react";
import { Form, DatePicker } from "antd";

const { RangePicker } = DatePicker;
export function InputRangeDate(props) {
  const [form] = Form.useForm();

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.initialValue}
      style={props.style}
      rules={[
        {
          required: props.required,
          message: props.errorMessage,
        },
      ]}
    >
      <RangePicker
        format={props.format}
        style={props.style}
        form={form}
        onChange={props.onChange}
        allowClear={props.allowClear}
        allowEmpty={props.allowEmpty}
        placeholder={props.placeholder}
        defaultPickerValue={props.defaultPickerValue}
        defaultValue={props.defaultValue}
        disabled={props.disabled}
        disabledTime={props.disabledTime}
        ranges={props.ranges}
        onCalendarChange={props.onCalendarChange}
        showTime={props.showTime}
        value={props.value}
        dateRender={props.dateRender}
        renderExtraFooter={props.renderExtraFooter}
        separator={props.separator}
      />
    </Form.Item>
  );
}
